<script lang="ts" setup>
  import { format } from 'date-fns'
  import { fr } from 'date-fns/locale'

  import { BngToast } from '~/layouts/components'

  type Props = {
    date?: Date
    displayed: boolean
  }
  const props = defineProps<Props>()
  const emit = defineEmits<{
    (e: 'close'): void
  }>()
  const formattedDate = computed(() => props.date ? format(props.date, 'dd MMMM yyyy \'à\' HH:mm', { locale: fr }) : null)

</script>
<template>
  <div class="c-reservation-confirmation-toast">
    <BngToast
      :content="{
        displayed: props.displayed,
        content: null,
        type: 'success',
      }"
    >
      <span
        v-if="formattedDate"
        class="text"
        :class="{ displayed: props.displayed }"
      >
        Votre réservation du&nbsp;<strong>{{ formattedDate }}</strong>
        &nbsp;a bien été ajoutée dans votre panier. Vous pouvez&nbsp;
        <NuxtLink
          class="link"
          style="text-decoration: underline"
          to="/"
        >
          continuer vos achats
        </NuxtLink>
        &nbsp;ou&nbsp;
        <NuxtLink
          class="link"
          style="text-decoration: underline"
          to="/shopping-cart/basket"
        >
          accéder à votre panier
        </NuxtLink>
        .
        <Button
          class="close-button"
          type="secondary"
          style="display: block"
          @click="emit('close')"
        >
          FERMER
        </Button>
      </span>
      <span
        v-else
        class="text"
        :class="{ displayed: props.displayed }"
      >
        Votre produit a bien été ajoutée dans votre panier. Vous pouvez&nbsp;
        <NuxtLink
          class="link"
          style="text-decoration: underline"
          to="/"
        >
          continuer vos achats
        </NuxtLink>
        &nbsp;ou&nbsp;
        <NuxtLink
          class="link"
          style="text-decoration: underline"
          to="/shopping-cart/basket"
        >
          accéder à votre panier
        </NuxtLink>
        .
        <Button
          class="close-button"
          type="secondary"
          style="display: block"
          @click="$emit('close')"
        >
          FERMER
        </Button>
      </span>
    </BngToast>
  </div>
</template>

<style scoped>
.c-reservation-confirmation-toast {
  position: absolute;
  z-index: 40;
  top: 3.875em;

  .text {
    display: none;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 0.5em;
    text-align: center;

    &.displayed {
      display: flex;
    }
  }

  .link {
    font-weight: bold;
    text-decoration: underline;
  }

  .close-button {
    position: relative;
    flex: 0;
    margin-left: 2em;
    font-size: 0.875em;
  }

  @media screen and (width >= 1024px) {
    top: 5.5em;
  }
}
</style>
